<div
    style="display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 100vh; background-color: #f8f9fa; font-family: 'PT Sans', sans-serif;">
    <div style="margin: 20px 0; text-align: center;">
        <img src="https://ello-bucket.s3.amazonaws.com/ello/6407d3b9a083250fe818445f43df85f2630f72db.svg" alt="Logo"
            style="max-width: 150px; height: auto;">
    </div>

    <div style="width: 100%; max-width: 450px; display: flex; justify-content: center; align-items: center;">
        <div
            style="width: 100%; padding: 30px 80px; border-radius: 70px; background-color: #000; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);">
            <div style="padding: 0;">
                <h2
                    style="font-size: 1.5rem; font-weight: bold; margin-bottom: 1rem; color: #a7b59b; text-align: left;">
                    Delete Account</h2>

                <form #deleteForm="ngForm" (ngSubmit)="onDeleteClick()" novalidate>
                    <div style="margin-bottom: 1rem;">
                        <label for="email"
                            style="color: #c9c9c9; padding: 0 15px; font-size: 16px; margin-bottom: 0.5rem; display: block;">Email</label>
                        <div style="position: relative;">
                            <input type="email" id="email" name="email" [(ngModel)]="email" placeholder="Email Address"
                                [disabled]="isLoading"
                                style="width: 100%; background: #ffffff40; border: 2px solid #ffffff66; backdrop-filter: blur(30px); padding: 15px 10px 15px 40px; border-radius: 15px; color: #fff !important; font-size: 1rem; outline: none; transition: border-color 0.2s ease;"
                                onfocus="this.style.borderColor='#58cdf8'; this.style.boxShadow='0 0 0 0.2rem rgba(88, 205, 248, 0.25)';"
                                onblur="this.style.borderColor='#ffffff66'; this.style.boxShadow='none';">
                            <i class="fa-solid fa-envelope"
                                style="font-size: 18px; color: #a7b59b; position: absolute; top: 50%; left: 15px; transform: translateY(-50%); margin: 0; pointer-events: none;"></i>
                        </div>
                        <div *ngIf="emailError"
                            style="color: #dc3545; font-size: 14px; margin-top: 0.25rem; padding-left: 15px;">
                            {{ emailError }}
                        </div>
                    </div>

                    <div style="margin-bottom: 1rem;">
                        <label for="password"
                            style="color: #c9c9c9; padding: 0 15px; font-size: 16px; margin-bottom: 0.5rem; display: block;">Password</label>
                        <div style="position: relative;">
                            <input type="password" id="password" name="password" [(ngModel)]="password"
                                placeholder="Password" [disabled]="isLoading"
                                style="width: 100%; background: #ffffff40; border: 2px solid #ffffff66; backdrop-filter: blur(30px); padding: 15px 10px 15px 40px; border-radius: 15px; color: #fff !important; font-size: 1rem; outline: none; transition: border-color 0.2s ease;"
                                onfocus="this.style.borderColor='#58cdf8'; this.style.boxShadow='0 0 0 0.2rem rgba(88, 205, 248, 0.25)';"
                                onblur="this.style.borderColor='#ffffff66'; this.style.boxShadow='none';">
                            <i class="fa-solid fa-lock"
                                style="font-size: 18px; color: #a7b59b; position: absolute; top: 50%; left: 15px; transform: translateY(-50%); margin: 0; pointer-events: none;"></i>
                        </div>
                        <div *ngIf="passwordError"
                            style="color: #dc3545; font-size: 14px; margin-top: 0.25rem; padding-left: 15px;">
                            {{ passwordError }}
                        </div>
                    </div>

                    <button type="submit" [disabled]="isLoading"
                        style="background: linear-gradient(180deg, #58cdf8, #067ed3); color: white; padding: 16px 30px; border: none; border-radius: 15px; font-size: 1rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; width: 100%; opacity: 1;"
                        onmouseover="if(!this.disabled) this.style.transform='translateY(-2px)'; if(!this.disabled) this.style.boxShadow='0 4px 8px rgba(6, 126, 211, 0.3)';"
                        onmouseout="if(!this.disabled) this.style.transform='translateY(0)'; if(!this.disabled) this.style.boxShadow='none';"
                        [style.opacity]="isLoading ? '0.7' : '1'"
                        [style.cursor]="isLoading ? 'not-allowed' : 'pointer'">
                        <span *ngIf="isLoading"
                            style="display: inline-block; width: 1rem; height: 1rem; border: 2px solid #fff; border-radius: 50%; border-top-color: transparent; animation: spin 1s linear infinite; margin-right: 0.5rem;"></span>
                        {{ isLoading ? 'Deleting...' : 'Delete Account' }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>

<!-- Confirmation Modal -->
<div *ngIf="showConfirmModal"
    style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; z-index: 1000;"
    (click)="onCancelDelete()">
    <div style="max-width: 500px; width: 90%; margin: 0 auto;" (click)="$event.stopPropagation()">
        <div style="background: white; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);">
            <div
                style="display: flex; justify-content: space-between; align-items: center; padding: 1rem; border-bottom: 1px solid #dee2e6;">
                <h5 style="font-size: 1.25rem; font-weight: bold; margin: 0; color: #333;">Confirm Deletion</h5>
                <button type="button" (click)="onCancelDelete()"
                    style="background: none; border: none; font-size: 1.5rem; line-height: 1; color: #333; cursor: pointer; padding: 0; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;">
                    <i class="fa-solid fa-times"></i>
                </button>
            </div>
            <div style="padding: 1rem; font-size: 1rem; color: #333;">
                Are you sure you want to delete your account? This action cannot be undone.
            </div>
            <div
                style="display: flex; justify-content: flex-end; gap: 0.5rem; padding: 1rem; border-top: 1px solid #dee2e6;">
                <button type="button" (click)="onCancelDelete()"
                    style="background-color: #6c757d; color: white; padding: 8px 16px; border: none; border-radius: 4px; font-size: 0.9rem; cursor: pointer; transition: background-color 0.2s;"
                    onmouseover="this.style.backgroundColor='#5a6268';"
                    onmouseout="this.style.backgroundColor='#6c757d';">
                    Cancel
                </button>
                <button type="button" (click)="onConfirmDelete()"
                    style="background-color: #dc3545; color: white; padding: 8px 16px; border: none; border-radius: 4px; font-size: 0.9rem; cursor: pointer; transition: background-color 0.2s;"
                    onmouseover="this.style.backgroundColor='#c82333';"
                    onmouseout="this.style.backgroundColor='#dc3545';">
                    OK
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Toast Notification -->
<div *ngIf="showToast" style="position: fixed; bottom: 1rem; right: 1rem; z-index: 1050;">
    <div
        style="background-color: #343a40; color: white; border-radius: 4px; min-width: 250px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);">
        <div style="display: flex; align-items: center; padding: 0.75rem;">
            <div style="flex: 1; font-size: 0.9rem;">{{ toastMessage }}</div>
            <button type="button" (click)="closeToast()"
                style="background: none; border: none; color: white; font-size: 1rem; margin-left: 0.5rem; cursor: pointer; padding: 0; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center;">
                <i class="fa-solid fa-times"></i>
            </button>
        </div>
    </div>
</div>

<!-- Spinner Animation -->
<style>
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>